import { createSlice, PayloadAction } from '@reduxjs/toolkit'
interface setPaintingIntroInfoI {
  class1: string //主题
  class2: string //类型
  mediaType: string //材质
  styleType: string //形制
  class3: string //题材
  materialType: string //设色
  description: string //简介内容
  workname: string //名称
  horizontal: string //长
  vertical: string //宽
  width: string //分辨率宽
  height: string //分辨率高
  dynasty: string //朝代
  authorname: string //作者
  // museum: string //博物馆
  instname: string //博物馆new
}

const initialState: setPaintingIntroInfoI = {
  class1: '',
  class2: '',
  mediaType: '',
  styleType: '',
  class3: '',
  materialType: '',
  description: '暂无信息',
  workname: '',
  horizontal: '',
  vertical: '',
  width: '',
  height: '',
  dynasty: '',
  authorname: '',
  // museum: "",
  instname: ''
}

export const setPaintingIntroInfoSlice = createSlice({
  name: 'setPaintingIntroInfo',
  initialState,
  reducers: {
    setClass1: (state, action: PayloadAction<string>) => {
      state.class1 = action.payload
    },
    setClass2: (state, action: PayloadAction<string>) => {
      state.class2 = action.payload
    },
    setMediaType: (state, action: PayloadAction<string>) => {
      state.mediaType = action.payload
    },
    setStyleType: (state, action: PayloadAction<string>) => {
      state.styleType = action.payload
    },
    setClass3: (state, action: PayloadAction<string>) => {
      state.class3 = action.payload
    },
    setMaterialType: (state, action: PayloadAction<string>) => {
      state.materialType = action.payload
    },
    setDescription: (state, action: PayloadAction<string>) => {
      state.description = action.payload
    },
    setWorkName: (state, action: PayloadAction<string>) => {
      state.workname = action.payload
    },
    setHorizontal: (state, action: PayloadAction<string>) => {
      state.horizontal = action.payload
    },
    setVertical: (state, action: PayloadAction<string>) => {
      state.vertical = action.payload
    },
    setHeadWidth: (state, action: PayloadAction<string>) => {
      state.width = action.payload
    },
    setHeadHeight: (state, action: PayloadAction<string>) => {
      state.height = action.payload
    },
    setDynasty: (state, action: PayloadAction<string>) => {
      state.dynasty = action.payload
    },
    setAuthorName: (state, action: PayloadAction<string>) => {
      state.authorname = action.payload
    },
    setMuseum: (state, action: PayloadAction<string>) => {
      state.instname = action.payload
    }
  }
})

export const {
  setClass1,
  setClass2,
  setMediaType,
  setStyleType,
  setClass3,
  setMaterialType,
  setDescription,
  setWorkName,
  setHorizontal,
  setVertical,
  setHeadWidth,
  setHeadHeight,
  setDynasty,
  setAuthorName,
  setMuseum
} = setPaintingIntroInfoSlice.actions
export default setPaintingIntroInfoSlice.reducer
